
export default function CardDisplay({card, runCard}) {
    function onClick() {
        runCard(card);
    }

    let exprs = [];

    for (let i = 0; i < card.expressions.length; ++i) {
        exprs.push(<div key={i} className="expr">{card.expressions[i].display()}</div>)
    }


    return <div className="card" onClick={onClick}>
        {exprs}
    </div>
}
